import ApiService from "@/services/api.service";

const buildSearchPecQuery = (params = {}) => {
    const query = new URLSearchParams();

    Object.entries(params).forEach(([key, value]) => {
        if (value === null || value === undefined || value === "") return;
        query.append(key, value);
    });

    return query.toString();
};

export default {
    namespaced: true,
    state: {
        listRubrica: {},
        loading: false,
        globalLoading: false,
        error: {},
    },
    getters: {
        getListRubrica: (state) => state.listRubrica,
        getLoading: (state) => state.loading,
        error: (state) => state.error,
    },
    mutations: {
        SET_RUBRICA_LIST(state, listRubrica) {
            state.listRubrica = listRubrica;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_GLOBAL_LOADING(state, val) {
            state.globalLoading = val;
        },
        SET_ERROR(state, val) {
            state.error = val;
        },
    },
    actions: {
        FETCH_LIST_RUBRICA({ commit }, query) {
            commit("SET_LOADING", true);

            return new Promise((resolve) => {
                ApiService.get(`Rubrica?${query}`)
                    .then((res) => {
                        commit("SET_RUBRICA_LIST", res.data);
                        commit("SET_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => {
                            commit("SET_ERROR", "");
                            commit("SET_LOADING", false);
                        }, 5000);
                    });
            });
        },

        GET_LIST_RUBRICA_BY_ID_MAIL_VIRTUALE({ commit }, id) {
            commit("SET_LOADING", true);

            return new Promise((resolve) => {
                ApiService.get(
                    `Rubrica/ddlByIdMailVirtuale?idMailVirtuale=${id}`
                )
                    .then((res) => {
                        commit("SET_RUBRICA_LIST", res.data.data);
                        commit("SET_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => {
                            commit("SET_ERROR", "");
                            commit("SET_LOADING", false);
                        }, 5000);
                    });
            });
        },

        CREATE_CONTACT({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);

            return new Promise((resolve, reject) => {
                ApiService.post(`Rubrica`, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        GET_CONTACT({ commit }, id) {
            return new Promise((resolve) => {
                ApiService.download(`Rubrica`, id)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                    });
            });
        },
        UPDATE_CONTACT({ commit }, params) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.update(`Rubrica`, params.id, params)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },
        DELETE_RUBRICA({ commit }, id) {
            commit("SET_GLOBAL_LOADING", true);
            return new Promise((resolve, reject) => {
                ApiService.delete(`Rubrica`, id)
                    .then((res) => {
                        commit("SET_GLOBAL_LOADING", false);
                        resolve(res);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        commit("SET_GLOBAL_LOADING", false);
                        reject(response);
                    });
            });
        },

        SEARCH_PEC_PREVIEW({ commit }, params) {
            const query = buildSearchPecQuery({
                ...params,
                dryRun: true,
                dataEnrichment: "advanced",
            });

            return new Promise((resolve, reject) => {
                ApiService.get(`Rubrica/searchPec?${query}`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        reject(response);
                    });
            });
        },

        SEARCH_PEC_RESULTS({ commit }, params) {
            const query = buildSearchPecQuery({
                ...params,
                dryRun: false,
                dataEnrichment: params?.dataEnrichment || "advanced",
            });

            return new Promise((resolve, reject) => {
                ApiService.get(`Rubrica/searchPec?${query}`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch(({ response }) => {
                        commit("SET_ERROR", response?.data?.message);
                        setTimeout(() => commit("SET_ERROR", ""), 5000);
                        reject(response);
                    });
            });
        },
    },
};
